@if (data?.type === directTypeEnum.SCREENSHOT) {
  <mat-card
    [attr.aria-label]="
      (data?.collectionInfo?.sourceName ?? 'screenshot')
        .replace(' ', '')
        .toLocaleLowerCase() + 'Miniature'
    "
    class="theme-bg-1--card border-color-1--card mat-elevation-z2 overflow-hidden relative max-h-[450px] min-h-[100px] rounded-2xl"
    [ngClass]="{
      'theme-bg-4--card border-blue-color-1--card-1': isSelectedData(),
      'opacity-50 grayscale cursor-not-allowed': isCorrupted,
    }"
    [matTooltip]="isCorrupted ? 'Corrupted information' : ''"
    [id]="data?.id ?? ''"
    (click)="isCorrupted ? $event.stopPropagation() : null"
  >
    <mat-card-title class="p-2">
      <div class="flex items-center align-middle w-full">
        <mat-icon class="flex-none material-icons-outlined">{{
          taDirectIcon
        }}</mat-icon>

        <span class="font-extrabold">
          {{ data?.collectionInfo?.sourceName ?? 'Unknown' }}</span
        >
      </div>
    </mat-card-title>

    <mat-card-content class="p-0 overflow-auto theme-bg-5">
      <div class="flex justify-center items-center shrink-0">
        <img
          class="object-contain w-full h-full shadow-sm max-h-[350px] min-h-[100px]"
          [attr.aria-label]="
            (data?.collectionInfo?.sourceName ?? 'screenshot')
              .replace(' ', '')
              .toLocaleLowerCase() + 'MiniatureImage'
          "
          [alt]="data?.collectionInfo?.sourceName ?? 'Screenshot'"
          (error)="imgError()"
          [src]="data?.imgproxy_urls?.thumbnail ?? ''"
          priority
          fit="cover"
        />
      </div>
      @if (data?.collectionInfo?.associatedSources?.length) {
        <div class="w-full py-2">
          <span class="text-sm theme-text-1">{{
            data?.collectionInfo?.associatedSources.join(', ')
          }}</span>
        </div>
      }
    </mat-card-content>

    <mat-card-footer class="right-0 left-0 bottom-0">
      <div class="w-full">
        @if (index) {
          <span class="float-start font-semibold px-2 pt-[2px]"
            >{{ index }}#</span
          >
        }
        @if (data?.eventTime) {
          <span
            class="float-end text-xs font-semibold px-2 py-1 md:whitespace-nowrapp rounded-br-md"
          >
            {{ data?.eventTime | date: 'yyyy-MM-ddTHH:mm:ss' : 'UTC' }}
          </span>
        }
      </div>
    </mat-card-footer>
  </mat-card>
} @else {
  <mat-card
    [attr.aria-label]="
      (data?.collectionInfo?.sourceName ?? 'item')
        .replace(' ', '')
        .toLocaleLowerCase() + 'Miniature'
    "
    class="overflow-hidden theme-bg-1--card border-color-1--card mat-elevation-z2"
    [ngClass]="{
      'theme-bg-4--card border-blue-color-1--card-1': isSelectedData(),
      'opacity-50 grayscale cursor-not-allowed': isCorrupted,
    }"
    [matTooltip]="isCorrupted ? 'Corrupted information' : ''"
    [id]="data?.id ?? ''"
    (click)="isCorrupted ? $event.stopPropagation() : null"
  >
    <mat-card-title class="p-2">
      <div
        class="flex flex-wrap content-between md:flex-nowrap items-center w-full"
      >
        <mat-icon class="flex-none material-icons-outlined">{{
          taDirectIcon
        }}</mat-icon>
        <span class="flex-none font-extrabold mx-2">
          {{ data?.collectionInfo?.sourceName ?? 'Unknown' }}
        </span>
        @let fileName = data?.file?.fileInfo?.name;
        @if (fileName) {
          <span class="text-sm theme-text-1 mx-2 min-w-0 truncate">{{
            fileName
          }}</span>
        }
        @if (data?.eventTime) {
          <span class="ml-auto flex items-center justify-center">
            @if (data?.attachments?.length) {
              <span
                [matTooltip]="
                  (data?.attachments?.length ?? 0) + ' attachment(s)'
                "
                class="material-icons scale-[0.8] mr-2"
                >description</span
              >
            }

            <span
              class="text-xs font-semibold px-2 py-1 rounded lg:whitespace-nowrap"
            >
              {{ data?.eventTime | date: 'yyyy-MM-ddTHH:mm:ss' : 'UTC' }}
            </span>
          </span>
        }
      </div>
      <div
        [matTooltip]="
          (data?.collectionInfo?.associatedSources ?? []).join(', ')
        "
        class="flex-auto min-w-0 truncate"
      >
        <span class="truncate text-sm theme-text-1">
          {{ (data?.collectionInfo?.associatedSources ?? []).join(', ') }}
        </span>
      </div>
    </mat-card-title>

    <mat-card-content class="theme-bg-3">
      <textarea
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="7"
        class="px-2 text-sm w-full resize-none overflow-hidden cursor-pointer theme-bg-3"
        disabled
        [value]="truncateText(textContent)"
      ></textarea>
    </mat-card-content>
  </mat-card>
}
